export const COMPANY_FORM_LIST = "COMPANY_FORM_LIST";
export const COMPANY_FORM_DATA = "COMPANY_FORM_DATA";
export const USER_DETAIL_BY_ID = "USER_DETAIL_BY_ID";
